/**
 * @generated SignedSource<<2ae92bc3428e9383b5c9528aa1905aab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorCommProgramDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCpTPayload",
        "kind": "LinkedField",
        "name": "deleteCpTByCpId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorCommProgramDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCpTPayload",
        "kind": "LinkedField",
        "name": "deleteCpTByCpId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65a0990fc6f9de77e35f855d23b986d7",
    "id": null,
    "metadata": {},
    "name": "VendorCommProgramDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation VendorCommProgramDeleteMutation(\n  $input: DeleteCpTByCpIdInput!\n) {\n  deleteCpTByCpId(input: $input) {\n    cpT {\n      cpId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d62fabe602286ba7a48145ef2a50e598";

module.exports = node;
